module.exports = __webpack_public_path__ + "img/airPurifiers_up.ff57e78b.png";